import { MessagesStatus } from 'app/models/messages';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Router } from '@angular/router';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from 'app/services/login/login.service';
import { FirmaElectronicaService } from '../../services/firma-electronica/firma-electronica.service';
import { environment } from 'environments/environment';

declare var $: any;

@Component({
  selector: 'app-pagare',
  templateUrl: './pagare.component.html',
  styleUrls: ['./pagare.component.scss'],
  providers:[MessagesStatus]
})
export class PagareComponent implements OnInit {
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  adjuntarPDF: boolean;
  loading:boolean;
  dataSource : any;
  pagares : any = [];
  datasesion : string;
  abrirPagare : boolean = false;
  abrirPagareAdqui : boolean = false;
  dataEnviar: any = {};  
  tipoServicio: any;
  desc_tipo:any;
  dataEnviarKeynua:any = {};
  razonSocial : any;
  ruta: any;
  rucEmpresa:any;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns: string[] = 
            ['checked','idPagare','Tipo_Pagare_Dsc','Fecha_Inicio','Fecha_Vencimiento','Estado','Adjunto_PDF','Adjunto_PDF_Firmado'];
            
  constructor(private router :Router,private empresaService : EmpresasService,
    private firmaElectronicaService:FirmaElectronicaService, private loginService :LoginService,private msgStatus:MessagesStatus) { }

  ngOnInit() {    
      if(this.empresaService.pagareDatos != null || this.empresaService.pagareDatos != undefined){   
        this.listadoPagares();
      }else {
        this.loginService.clickGuard = true; 
        this.router.navigate(['/empresas/proveedor/listado']);
      }
      this.rucEmpresa=sessionStorage.getItem('rucEmpresa');
      let rutas = this.router.url.split("/",3);
      this.ruta = rutas[2];
      const elem=document.getElementById('button-oculto');
    elem.style.display='none';
  }
  Regresar(id:any=this.rucEmpresa){
    if (this.ruta == 'proveedor') {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/proveedor/listado/',id]);
    } else {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/adquirente/listado/',id]);
    }
  }
  listadoPagares(){    
    this.loading = true;
    this.razonSocial = this.empresaService.pagareDatos.Razon_Social;
    this.empresaService.ListadoPagares(this.empresaService.pagareDatos.idEmpresa, this.empresaService.pagareDatos.Tipo_Servicio,0,0).subscribe(
      res=>{
        this.pagares = res;   
        this.dataSource = new MatTableDataSource(this.pagares);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      }, err=>{
        Swal.fire({
          title: "¡Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick : true,
          heightAuto: false
        });
       this.loading = false;   
    }
      )
  }

  altaPagare(element:any){
    this.adjuntarPDF = true;
    this.empresaService.dataPagare = element;  
  }

  cerrarPopUpFirmado(){
    this.adjuntarPDF = false;
   }

  BajaPagare(id: any, estado :any) {
    this.loading = true;

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-i-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: '¿Está seguro de desactivar este pagaré?',
      text: '',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      reverseButtons: true,
      heightAuto: false
    })
      .then((result) => {
        this.loading = true;
        if (result.value) {
          this.dataEnviar.idPagare = id;
          this.dataEnviar.Estado = "B";
          this.empresaService.BajaPagare(this.dataEnviar)
            .subscribe(res => {
              this.loading = false;
              swalWithBootstrapButtons.fire({
                title: 'Éxito',
                text:'El pagaré se desactivó correctamente.',
                type: 'success',
                heightAuto: false
            })
              .then(resp => {
                if (resp.value == true) {
                  this.listadoPagares();
                }
              });
            },(err: HttpErrorResponse)=> {
              this.loading=false;
              if (err.error instanceof ErrorEvent) {
                console.error("Error Event");
            } else {
                this.msgStatus.getMessage(err.status);            
            }
              Swal.fire({
                title: 'Error',
                text: ""+this.msgStatus.message ,
                type: "error",
                allowOutsideClick: true,
                heightAuto: false
              })
            })
        } else if (          
          result.dismiss === Swal.DismissReason.cancel          
        ) {
          this.loading = false
        }else{
          this.loading = false
        }
      }
      )
  }

CrearPagare(){
  this.empresaService.tipoServicio = this.tipoServicio
    if (this.tipoServicio == this.Id_Factoring) {
    this.abrirPagare = true;
    }else{
      this.abrirPagareAdqui = true;
    }
  this.abrirPagare = true;
}
CerrarNuevoPagare(){
  this.abrirPagare = false;
}

enviarContratoKeynua(idPagare :any){
  Swal.fire({
    title: 'Send promissory note to e-Sign',
    text: '¿Desea enviar el contrato digital a firma electrónica?',
    type: "info",
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí',
    cancelButtonText: 'No',
    heightAuto: false
  }).then((result) => {
    if (result.value) {
      this.dataEnviarKeynua.idPagare = idPagare;
      this.enviarPagareElectronico(this.dataEnviarKeynua);
    }else if (
      result.dismiss === Swal.DismissReason.cancel
    ) {
      this.loading = false;
    }
  });
}

enviarPagareElectronico(dataEnviarKeynua){
 Swal.fire({
  title: 'Espere',
  text: 'Enviando pagaré a firma electrónica.',
  type: 'info',
  heightAuto: false
 });
Swal.showLoading();
 this.firmaElectronicaService.enviarPagareElectronico(dataEnviarKeynua).subscribe(
     res => {  
      Swal.close();     
       this.showNotification('success','top','right','Documento enviado correctamente a firma electrónica.');
     },err => {
      if (err.error.message) {
       this.showNotification('warning','top','right','Could not send digital contract to e-Sign. \n Error: ' + err.error.message);
      }else{
       let error = "";
       error = err.error.error;
       this.showNotification('warning','top','right','Could not send digital contract to e-Sign. \n Error: ' + error);
      }
    
    }
 );
}

showNotification(type,from,align,message){

  $.notify({
      icon: "notifications",
      message: message
  },{
      type: type,
      timer: 4000,
      placement: {
          from: from,
          align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>'
  });
}

}
